/**
 * Utility functions for handling and formatting names
 */

/**
 * Formats a name from "LastName FirstName" to "FirstName LastName" format
 * @param {string} name - The name to format (usually in "LastName FirstName" format)
 * @returns {string} - The formatted name in "FirstName LastName" format
 */
export const formatName = (name) => {
  if (!name) return '';

  // Split the name into parts
  const nameParts = name.trim().split(/\s+/);

  // If there's only one part, return it as is
  if (nameParts.length <= 1) {
    return name;
  }

  // Assume the first part is the last name and the rest is the first name(s)
  const lastName = nameParts[0];
  const firstName = nameParts.slice(1).join(' ');

  // Return in "FirstName LastName" format
  return `${firstName} ${lastName}`;
};

/**
 * Gets the first name from a full name
 * @param {string} name - The full name
 * @returns {string} - The first name
 */
export const getFirstName = (name) => {
  const formattedName = formatName(name);
  const parts = formattedName.split(' ');
  return parts[0] || '';
};

/**
 * Gets the last name from a full name
 * @param {string} name - The full name
 * @returns {string} - The last name
 */
export const getLastName = (name) => {
  const formattedName = formatName(name);
  const parts = formattedName.split(' ');
  return parts.length > 1 ? parts[parts.length - 1] : '';
};